import { FC, KeyboardEvent, useEffect } from "react";
import { useI18n } from "../../hooks/useTranslations";
import Button from "../ui/Button";
import Form from "../ui/Form";
import FormField from "../ui/FormField";
import Input from "../ui/Input";
import styles from "./UpdateAvailabilityDateForm.module.css";

export interface UpdateAvailabilityDateFormBody {
  date: string;
}
type UpdateAvailabilityDateFormProps = {
  date?: string | null;
  onSubmit: (data: UpdateAvailabilityDateFormBody) => void;
};

const UpdateAvailabilityDateForm: FC<UpdateAvailabilityDateFormProps> = ({ date, onSubmit }) => {
  const i18n = useI18n();

  const defaultValues = {
    date: date ?? undefined,
  };

  return (
    <Form<UpdateAvailabilityDateFormBody> defaultValues={defaultValues} mode="onSubmit">
      {({ formState: { errors }, reset, register, trigger, watch }) => {
        const submit = async () => {
          const res = await trigger();
          if (res) {
            onSubmit(watch());
            // reset();
          }
        };

        useEffect(() => {
          reset(defaultValues);
        }, [date]);

        return (
          <FormField label={i18n.t.common.availabilityDate} error={errors.date}>
            {({ labelId, isInvalid }) => (
              <div className={styles.inline}>
                <Input
                  id={labelId}
                  isInvalid={isInvalid}
                  {...register("date")}
                  onKeyDown={(e: KeyboardEvent<HTMLInputElement>) => {
                    if (e.key === "Enter") {
                      e.preventDefault();
                      submit();
                    }
                  }}
                  type="date"
                />
                <Button
                  buttonProps={{
                    onClick: submit,
                  }}
                >
                  {i18n.t.common.save}
                </Button>
              </div>
            )}
          </FormField>
        );
      }}
    </Form>
  );
};

export default UpdateAvailabilityDateForm;
